import {copyToClipboard, showSnackbar} from '@dvrd/dvr-controls';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {CHROME_EXTENSION_ROUTE, CHROME_EXTENSION_STORE_URL} from '../../util/constants';
import {onSetCrumbs} from '../../util/events';
import ChromeExtension from './chromeExtension';

export default function ChromeExtensionController() {
    const {t} = useTranslation();

    function onShare() {
        void copyToClipboard(CHROME_EXTENSION_STORE_URL)
            .then(() => showSnackbar(t('chromeExtension.shareCopied', 'De link is gekopieerd')))
            .catch(() => showSnackbar(t('chromeExtension.shareFailed', 'Kopiëren is niet gelukt')));
    }

    useEffect(() => {
        onSetCrumbs([{label: t('chromeExtension.crumb', 'Chrome Extensie'), route: CHROME_EXTENSION_ROUTE}]);
    }, []);

    return <ChromeExtension onShare={onShare} />;
}
